import Cropper from "react-easy-crop";
import { useState, useCallback, useRef, useEffect } from "react";
import { Button, RangeSlider } from "flowbite-react";
import { getCroppedImg } from "../../utils/utils";

const CropModal = ({ image, onCropComplete, onCancel }) => {
  const containerRef = useRef(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1.5);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [cropSize, setCropSize] = useState(null);

  // Centraliza o cropSize com base no container
  useEffect(() => {
    if (containerRef.current) {
      const { offsetWidth, offsetHeight } = containerRef.current;
      const size = Math.floor(Math.min(offsetWidth, offsetHeight) * 0.8);
      setCropSize({ width: size, height: size });
    }
  }, []);

  const handleCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleConfirm = async () => {
    if (!croppedAreaPixels) return;
    const croppedImage = await getCroppedImg(
      image,
      croppedAreaPixels,
      rotation
    );
    onCropComplete(croppedImage);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
      <div className="flex flex-col items-center w-full max-w-3xl">
        <div
          ref={containerRef}
          className="relative w-full h-[400px] md:h-[500px] bg-black rounded-md overflow-hidden"
        >
          {cropSize && (
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              minZoom={0.3}
              maxZoom={3}
              rotation={rotation}
              aspect={1}
              cropSize={cropSize}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onRotationChange={setRotation}
              onCropComplete={handleCropComplete}
              restrictPosition={false}
            />
          )}
        </div>

        <div className="w-full px-4 mt-4">
          <label htmlFor="zoomRange" className="text-white block mb-1">
            Zoom: {zoom.toFixed(1)}x
          </label>
          <RangeSlider
            id="zoomRange"
            min={0.3}
            max={3}
            step={0.01}
            value={zoom}
            onChange={(e) => setZoom(parseFloat(e.target.value))}
          />
        </div>

        <div className="flex gap-3 mt-6">
          <Button color="gray" onClick={onCancel}>
            Cancelar
          </Button>
          <Button
            color="warning"
            onClick={() => setRotation((prev) => prev - 90)}
          >
            Girar ↺
          </Button>
          <Button onClick={handleConfirm}>Recortar</Button>
        </div>
      </div>
    </div>
  );
};

export default CropModal;
